import React from 'react'
import { Link } from 'react-router-dom'
import avater from '../../../assets/img/common/avater.png'
import { useSelector, useDispatch } from "react-redux";
import { useHistory } from "react-router-dom"
import Swal from 'sweetalert2';
import { HOME_URL, LOGIN_URL, ORDERS_URL, REGISTER_URL } from '../../../app/constants';

const TopHeader = () => {
    let dispatch = useDispatch();
    const history = useHistory()

    let status = useSelector((state) => state.user.status);
    let user = useSelector((state) => state.user.user);

    const logout = () => {
        Swal.fire({
            icon: 'success',
            title: 'Logout Sucessfull',
            text: 'Thank You'
        })
        dispatch({ type: "user/logout" })
        history.push(LOGIN_URL);
    }
    return (
        <>
            <section id="top_header">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-6 col-md-6 col-sm-12 col-12">
                            <div className="top_header_left">
                            </div>
                        </div>
                        <div className="col-lg-6 col-md-6 col-sm-12 col-12  ">
                            <div className="top_header_right"  >
                                {
                                    !status ?
                                        <ul className="right_list_fix">
                                            <li><Link to={LOGIN_URL}><i className="fa fa-user"></i> Login</Link></li>
                                            <li><Link to={REGISTER_URL}><i className="fa fa-lock"></i> Register</Link></li>
                                        </ul>
                                        :
                                        <ul className="right_list_fix" style={{ display: "flex", flexWrap: "wrap" }} >
                                            <li className="after_login"><img src={avater} alt="avater" /> {user.email} <i className="fa fa-angle-down"></i>
                                                <ul className="custom_dropdown">
                                                    <li><Link to={ORDERS_URL}><i className="fa fa-cubes"></i> My Orders</Link></li>
                                                    <li><Link to={HOME_URL} onClick={() => { logout() }} ><i className="fa fa-sign-out"></i> Logout</Link></li>
                                                </ul>
                                            </li>
                                        </ul>
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}

export default TopHeader